// extracted by mini-css-extract-plugin
module.exports = {"health":"health-3IFhD05f"};